export default {

  methods: {


    /**
     @param data array
     @param colors string of Hex colors, comma separated; or array
     @param title string, optionally {TITLE}|{COLOR}
     @param colInd integer, if titlee has color, index in data array.

     @return mixed - data array, colours array, legends array
    */
    fillChart (data, colors = null, title = null, colInd = 0) {

      var chartData = {data: [], colors: [], legends: [], title: null, total: null}

      for (let i = 0 ; i < data.length ; i++) {

        if (data[i][1]) {
          chartData.data.push(data[i])
          chartData.legends.push(data[i][0])

          if (!this.isArray(title)) {
            let t = (title ? title.split('|') : null)

            if (colors && colors.length > 0) {

              if (colInd === i) {

                if (t.length === 2) {
                  chartData.colors.push(t[i])
                } else {
                  chartData.colors.push(colors[i])
                }

              } else {
                chartData.colors.push(colors[i])
              }  // if colInd == i

            } // if colors..

            chartData.title = t[0]
          } else {

            chartData.colors.push(colors[i])

            if (title) {
              chartData.title = title
            }

          }

        }

      } // for

      if (chartData.data.length === 0) {
        chartData = null
      } else {
        chartData.total = chartData.data.length
      }

      return chartData
    },



    /**
     @param data array
     @param titles string of titles, comma separated; or array, {TITLE}|{COLOR}
     @param mutli boolean - is data array multi-dimensional
     @param colInd integer, index in data array for appling title color.

     @return mixed - data array, colours array, legends array
    */
    preparePieChart (data, colors = null, titles = null, multi = false, colInd = 0) {
      var chartData = []
      var c = []
      var t = []

      if (this.isArray(colors)) {
        c = colors
      } else {

        if (colors) {
          colors = colors.replace(/\s/g, '')
          c = colors.split(',')
        }

      }


      if (this.isArray(titles)) {
        t = titles
      } else {

        if (titles) {
          titles = titles.replace(/\s/g, '')
          t = titles.split(',')
        }

      }

      if (multi) {

        for (let i = 0 ; i < data.length ; i++) {
            let chart = this.fillChart(data[i], c, (this.isArray(t) ? t[i] : null), colInd)

            if (chart) {
               chartData.push( chart )
            }

        }  // for

      } else {
        chartData = this.fillChart(data, c, t, colInd)
      }

      return chartData
    }
  }


}
